<template>
    <div class="cardlistbg">
        <div :id="getid" :class="{cardlisttitle:true, titlenow:darktext}" @click="changeflag">
            {{title}}
            <div class="arrowimg">
                <img v-if="!contentflag" src="https://p3.udn.com.tw/wish/images/side_menu/side_down.svg" />
                <img v-else src="https://p3.udn.com.tw/wish/images/side_menu/side_up.svg" />
            </div>
        </div>
        <div class="cardlistcontent" :style="{height: thisheight + 'px'}">
            <div :id="id" class="cardlist">
                <side_wishercard 
                    v-for="data in cardinfo"
                    :key="data.name"
                    :site_name="data.site_name"
                    :name="data.name"
                    :title="data.title"
                />
            </div>
        </div>
        
    </div>
</template>

<script>
    import { sendGaMethods } from '@/assets/js/utils/masterBuilder.js';
    import side_wishercard from '@/components/common/side_wishercard.vue'
    export default {
        mixins: [sendGaMethods],
        props: {
            id: { type: String },
            title: { type: String },
            cardinfo: { type: Array },
        },
        components: {
            side_wishercard
        },
        data(){
            return{
                thisheight: 0,
                contentflag: false,
                darktext: false,
            }
        },
        mounted(){
            this.cardinfo.forEach(element => {
                if(element["site_name"]==this.$store.state.currentwisher){
                    this.darktext=true;
                    this.contentflag = true;
                    this.thisheight=document.getElementById(this.id).offsetHeight;
                }
            });
        },
        computed:{
            getid(){
                return this.id+"anchor"
            }
        },
        methods:{
            changeflag(){
                if(!this.contentflag) this.sendGA({category: 'wisher bar category', action: 'click', label: 'click_wisher_bar_'+this.cardinfo[0]['site_name'].split('_')[0]});
                this.contentflag = !this.contentflag;
                if(this.contentflag) this.thisheight=document.getElementById(this.id).offsetHeight;
                else this.thisheight=0;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .cardlistbg{
        position: relative;
        width: 255px;
        @media (min-width: 400px) AND (max-width: 550px) {
            width: 375px;
        }
        @media (min-width: 550px) AND (max-width: 768px) {
            width: 500px;
        }
        @media (min-width: 768px) AND (max-width: 960px) {
            width: 620px;
        }
        @media (min-width: 960px) AND (max-width: 1120px) {
            width: 960px;
        }
        @media (min-width: 1120px) {
            width: 1120px;
        }
        margin: auto;
        margin-top: 50px;
        margin-bottom: 50px;
        overflow: hidden;
        text-align: center;
        @media (min-width: 768px) {
            text-align: start;
        }
        .cardlisttitle{
            position: relative;
            max-width: 1280px;
            margin: auto;
            font-size: 24px;
            line-height: 36px;
            padding-bottom: 15px;
            border-bottom: 1px solid #C7C7C7;
            color: #1D1C1B;
            opacity: 0.5;
            cursor: pointer;
            font-family: 'Noto Serif TC';
            font-weight: bold;
            @media (min-width: 768px) {
                font-size: 30px;
                line-height: 40px;
            }
            .arrowimg{
                display: inline-block;
                margin-left: 10px;
            }
        }
        .titlenow{
            opacity: 1;
        }
        .cardlistcontent{
            position: relative;
            height:0;
            max-width: 1280px;
            margin: auto;
            transition: height 0.5s;
            .cardlist{
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
            }
        }
    }
</style>